import * as React from 'react';
import Box from '@mui/material/Box';
import Alert from '@mui/material/Alert';
import IconButton from '@mui/material/IconButton';
import Collapse from '@mui/material/Collapse';
import CloseIcon from '@mui/icons-material/Close';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { signOut } from '../actions/accountActions';

export default function MessageError({ message }) {
    const [open, setOpen] = React.useState(true);
    const [messageRetificada, setMessageRetificada] = React.useState(null);
    const dispatch = useDispatch();
    const navigate = useNavigate();

    // CASO O SESSAO ESTIVER EXPIRADA DEVE FAZER LOGOUT DO SISTEMA
    if (message === 'jwt expired') {
        dispatch(signOut());
        dispatch({
          type: 'alert',
          payload: { alert: 'Sessão expirada. Faça login novamente' },
        });
        navigate('/login')
    }


    // CASO O TIVER ALGUM PROBLEMA COM EMAIL DO DESTINATARIO
    // You tried to send to recipient(s) that have been marked as inactive. Found inactive addresses: emailteste@gmail.com. Inactive recipients are ones that have generated a hard bounce, a spam complaint, or a manual suppression.
    React.useEffect(() => {
        if (message && message.includes('You tried to send to recipient(s) that have been marked as inactive. Found inactive addresses')) {
            setMessageRetificada(
                'Não foi possível entregar sua mensagem porque o endereço de e-mail do destinatário está marcado como inativo. Isso pode ocorrer quando alguém marca mensagens como spam ou solicita não receber mais comunicações. Recomendamos verificar ou atualizar o endereço de e-mail antes de tentar novamente.'
            );
        }
    }, [message]);

    return (
        <Box sx={{ width: '100%' }}>
            <Collapse in={open}>
                {/* INPUT PARA DAR FOCO NO COMPONENTE ASSIM QUE FOR EXIBIDO */}
                <input autoFocus type="text" style={{ opacity: 0, height: 1 }} />
                <Alert
                    severity="error"
                    action={
                        <IconButton
                            aria-label="close"
                            color="inherit"
                            size="small"
                            onClick={() => { setOpen(false); }}
                        >
                            <CloseIcon fontSize="inherit" />
                        </IconButton>
                    }
                    sx={{ mb: 2 }}
                >
                    <span style={{ marginTop: 20, lineHeight: 1.5 }} dangerouslySetInnerHTML={{ __html: messageRetificada ?? message }} />
                    {/* {message} */}
                </Alert>
            </Collapse>
        </Box>
    );
}